(function () {
	const header = () => {
		const megaMenuLinks = document.querySelectorAll(".list-menu--megamenu");
		megaMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", () => {
				link.classList.add("list-menu--megamenu-visible");

				link.addEventListener("mousemove", () => {
					link.classList.add("list-menu--megamenu-visible");
				});

				link.addEventListener("mouseleave", () => {
					setTimeout(() => {
						link.classList.remove("list-menu--megamenu-visible");
					}, 300);
					link.addEventListener("mouseenter", () => {
						link.classList.add("list-menu--megamenu-visible");
					});
				});
			});
		});
	};

	document.addEventListener("shopify:section:load", header);

	header();

    if (window.matchMedia("(max-width: 767px)").matches) {
      document.addEventListener("DOMContentLoaded", function () {
        const amazingGiftsButton = document.querySelector(
          'summary[aria-controls="link-Amazing Gifts"]'
        );

        if (amazingGiftsButton) {
          const arrowIcon = amazingGiftsButton.querySelector(".icon-caret");
          if (arrowIcon) {
            arrowIcon.style.display = "none";
          }

          amazingGiftsButton.addEventListener("click", function (event) {
            event.preventDefault();
            window.location.href = "/pages/amazing-gifts";
    	  });
    	}
      });
    }
})();